import { useField, useFormikContext } from 'formik';
import { RefObject } from 'react';
import {
  AddressAutofill,
  AddressAutofillProps,
} from 'shared/form/AddressAutofill';
export interface FormikAddressAutofillProps extends Omit<
  AddressAutofillProps,
  'value' | 'error' | 'onBlur' | 'onChange'
> {
  name: string;
  startText?: string;
  address?: string;
  errorMsg?: string;
  onBlur?: () => void;
  inputRef?: RefObject<HTMLInputElement>;
}

export function FormikAddressAutofill({
  name,
  disabled,
  helperText,
  errorMsg,
  onBlur,
  inputRef,
  ...props
}: FormikAddressAutofillProps) {
  const { isSubmitting } = useFormikContext();
  const [, { value, error, touched }, { setValue, setTouched }] =
    useField<string>(name);
  const errorText = touched && (error || errorMsg);

  return (
    <AddressAutofill
      {...props}
      inputRef={inputRef}
      value={value || ''}
      error={!!errorText}
      helperText={errorText || helperText}
      disabled={disabled || isSubmitting}
      onBlur={(nextValue) => {
        void setTouched(true, false);
        void setValue(nextValue, true);
        onBlur?.();
      }}
      onChange={(nextValue) => {
        void setValue(nextValue);
      }}
    />
  );
}
